import React from 'react';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const product = {
    name: "Natural Firming Facial Serum",
    description: "A concentrated, plant-based formula designed to support skin firmness, elasticity and a healthy-looking complexion.",
    details: [
      { label: "Skin benefits", value: "Firming, smoothing, regenerating" },
      { label: "Skin type", value: "Normal, dry, mature" },
      { label: "Texture", value: "Lightweight, oil-based" },
      { label: "Scent", value: "Subtle, natural" },
      { label: "When to use", value: "Morning and/or evening" }
    ],
    imageUrl: "/images/newimage.webp"
  };

  return (
    <div className="product-container">
      <div className="product-card">
        {/* Left Column - Text Info */}
        <div className="product-info-col">
          <h1 className="product-title">{product.name}</h1>
          <p className="product-description">{product.description}</p>

          {/* Details List - exactly like image table format */}
          <div className="details-list">
            {product.details.map((item, index) => (
              <div key={index} className="detail-row">
                <span className="detail-label">{item.label}</span>
                <span className="detail-value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column - Image Full Width */}
        <div className="product-image-col">
          <img 
            src={product.imageUrl} 
            alt={product.name}
            className="product-image-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductShowcase;